import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  SetupConfiguration,
  SetupConfigurationService
} from 'src/app/services/setup-configuration.service';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-card-updater',
  templateUrl: './card-updater.component.html',
  styleUrl: './card-updater.component.scss',
  providers: [MessageService]
})
export class CardUpdaterComponent implements OnInit {
  private title = inject(Title);
  private setupConfigurationService = inject(SetupConfigurationService);
  private messageService = inject(MessageService);

  configs: SetupConfiguration[] = [];
  saving: { [id: number]: boolean } = {};

  async ngOnInit() {
    this.title.setTitle('Card Updater');
    await this.loadConfigs();
  }

  async loadConfigs() {
    LoaderService.showLoader();
    try {
      this.configs = await lastValueFrom(
        this.setupConfigurationService.getCardUpdaterConfigurations()
      );
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async onToggle(config: SetupConfiguration, enabled: boolean) {
    if (!config.configurationId) {
      return;
    }
    const previous = config.isEnabled;
    config.isEnabled = enabled;
    this.saving[config.configurationId] = true;
    try {
      const updated = await lastValueFrom(
        this.setupConfigurationService.updateConfiguration(
          config.configurationId,
          enabled
        )
      );
      config.isEnabled = updated.isEnabled;
      config.dateUpdated = updated.dateUpdated;
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: `"${config.name}" ${enabled ? 'habilitada' : 'desabilitada'}`
      });
    } catch (error) {
      config.isEnabled = previous;
      AppDialogService.showErrorDialog(error);
    } finally {
      this.saving[config.configurationId] = false;
    }
  }
}
